import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-divisa-list',
  templateUrl: './divisa-list.component.html',
  styleUrls: ['./divisa-list.component.scss'],
})
export class DivisaListComponent {
  @Input() divisa!: any;
  @Output() divisaSelected = new EventEmitter<any>();

  openDialog() {
    this.divisaSelected.emit(this.divisa);
  }
}
